"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var helpers_1 = require("../../helpers");
var NOTIFICATION_HEIGHT = 32;
var computeAvailableRowsHeight = function (_a) {
    var data = _a.data, headerHeight = _a.headerHeight, rowHeight = _a.rowHeight, pagination = _a.pagination, selection = _a.selection, hideHeader = _a.hideHeader, totalRow = _a.totalRow, height = _a.height, subheaderHeight = _a.subheaderHeight, notification = _a.notification;
    var h;
    if (typeof height === 'string') {
        h = data.length * rowHeight;
    }
    else {
        h = !hideHeader ? height - headerHeight : height;
        if (pagination) {
            h -= 48;
        }
        if ((selection === null || selection === void 0 ? void 0 : selection.multiple) && selection.subheaderRenderer !== null) {
            h -= parseInt(helpers_1.SPACING_XL, 10);
        }
        if (totalRow) {
            h -= parseInt(helpers_1.SPACING_XL, 10);
        }
        if (subheaderHeight) {
            h -= subheaderHeight;
        }
        if ((notification === null || notification === void 0 ? void 0 : notification.position) === types_1.GRID_NOTIFICATION_POSITION.offset) {
            h -= NOTIFICATION_HEIGHT;
        }
    }
    return h;
};
exports.default = computeAvailableRowsHeight;
//# sourceMappingURL=computeAvailableRowsHeight.js.map